import { AudiencesState } from './types';

export const initialState: AudiencesState = {
  loadingPasscodeList: false,
  passcodeLists: [],
  loadingPasscodeLists: false,
  passcodeListMembers: [],
  loadingPasscodeListMembers: false,
  showAddPasscodeListModal: false,
  paidLists: {},
  globalCurrencies: null,
  loadingPaidListMembers: false,
  paidListMembers: null,
  passcodeListMemberCount: 0,
};
